var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneCircleBrand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6638_28007)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6638_28007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 18.2135C8.60871 16.8228 7.51858 15.1729 6.72898 13.2637C5.93938 11.3545 5.57993 9.3157 5.65064 7.14724C5.65064 6.8644 5.74492 6.6287 5.93349 6.44013C6.12205 6.25157 6.35775 6.15729 6.64059 6.15729L9.85793 6.19264C10.1172 6.19264 10.3382 6.27219 10.5208 6.43129C10.7035 6.59039 10.8125 6.79369 10.8479 7.04117L11.3429 10.6474C11.3664 10.8124 11.3546 10.9656 11.3075 11.107C11.2604 11.2485 11.1779 11.3781 11.06 11.4959L9.04476 13.5112C9.35117 14.1005 9.69883 14.672 10.0877 15.2259C10.4766 15.7798 10.9186 16.3043 11.4136 16.7992C11.9085 17.2942 12.433 17.7362 12.9869 18.1251C13.5408 18.514 14.1124 18.8616 14.7016 19.1681L16.7169 17.1528C16.8347 17.0349 16.9644 16.9525 17.1058 16.9053C17.2472 16.8582 17.4004 16.8464 17.5654 16.87L21.1716 17.3649C21.4191 17.4003 21.6224 17.5093 21.7815 17.692C21.9406 17.8746 22.0202 18.0956 22.0202 18.3549L22.0555 21.5722C22.0555 21.8551 21.9612 22.0908 21.7727 22.2793C21.5841 22.4679 21.3484 22.5622 21.0656 22.5622C18.9089 22.6447 16.873 22.2882 14.9579 21.4927C13.0429 20.6972 11.39 19.6041 9.99935 18.2135Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6638_28007"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6638_28007"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12.8281 32.3557) rotate(-135)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCircleBrand);
export default __webpack_public_path__ + "static/media/phone_circle_brand.83312a6ab8a3f20ca0e73bea08cde2e5.svg";
export { ForwardRef as ReactComponent };